import BaseModal from "../BaseComponents/BaseModal/BaseModal";
import { useSubscriberById } from "../../api/cms/useSubscribersApi";
import styles from "./ViewSubscriberModal.module.css";

const ViewSubscriberModal = ({ open, onClose, data }) => {
  const subscriberId = open && data?.id ? data.id : null;
  const { data: subscriber, loading } = useSubscriberById(subscriberId);

  const display = subscriber || data;

  if (!display && !data) return null;

  return (
    <BaseModal
      open={open}
      onClose={onClose}
      title="Subscriber Details"
      width="620px"
      footer={
        <button className={styles.closeBtn} onClick={onClose}>
          Close
        </button>
      }
    >
      {loading ? (
        <p className={styles.loading}>Loading details…</p>
      ) : (
        <>
          <div className={styles.grid}>
            <div>
              <label>Email</label>
              <p>{display?.email}</p>
            </div>

            <div>
              <label>Name</label>
              <p>
                {display?.firstName || display?.lastName
                  ? `${display?.firstName || ""} ${display?.lastName || ""}`.trim()
                  : "—"}
              </p>
            </div>

            <div>
              <label>Source</label>
              <p>{display?.source || "—"}</p>
            </div>

            <div>
              <label>Subscribed At</label>
              <p>{display?.subscribedAt || "—"}</p>
            </div>
          </div>

          <div className={styles.history}>
            <h4>Activity & History</h4>
            <ul>
              {(display?.history && Array.isArray(display.history)
                ? display.history
                : []
              ).map((h, i) => (
                <li key={i}>{typeof h === "string" ? h : h?.event ?? ""}</li>
              ))}
            </ul>
            {(!display?.history || display.history.length === 0) && (
              <p className={styles.noHistory}>No activity yet.</p>
            )}
          </div>
        </>
      )}
    </BaseModal>
  );
};

export default ViewSubscriberModal;
